import React, {  Component } from 'react';
import { connect } from 'react-redux';

import _ from 'lodash';


/* Actions */
import { getShippingAddresses } from '../../../redux/actions';

class CarrierInfo extends Component {

	constructor(props) {
		super(props);
		this.state = {
            inputZipcode:'',
			shippingAddress: null,
			errorMessage: '',
			errorFlag: false,
			willCallLocData: null,
			adcLocData: null,
			isServiceProvided: false,
			cntrlPressed: false,
			isSelected: false
		}
	}

	// get zipcode value
	handleSearchInput(event){
        this.setState({
            inputZipcode: event.target.value
        });
    }

	// search result from zipcode
    handleSearchResult(event){
		const self = this;
		// set null before calling service
		self.setState({
			shippingAddress: null,
			errorMessage: '',
			errorFlag: false,
			willCallLocData: null,
			adcLocData: null,
			isServiceProvided: false
		});

		self.props.fireGTMTag('Carrier Search', {
			searchTerm: self.state.inputZipcode,
			searchType: 'carrier'
		});

		//check zipcode length
		if(self.state.inputZipcode.length !== 5 || isNaN(self.state.inputZipcode)) {
			self.setState({
				errorFlag: true,
				errorMessage: 'Please enter 5 digit number zipcode.'
			})
        } else {
			//call method for shipping address
			let country = "US";
			const numericRegex = /^[0-9]*$/;
			if (self.state.zipCode && self.state.zipCode.indexOf(' ') !== -1 && !numericRegex.test(self.state.zipCode)) {					
				country = "CA"
			}
			self.props.getShippingAddresses(`zip=${self.state.inputZipcode}&accountNumber=${self.props.getSelectedAccountNumber()}&country=${country}`, true, (resp) => {
				if(!resp.status) {
					self.setState({
						errorFlag: true,
						errorMessage: 'Please enter valid zipcode.'
					})
				} else {
					const sdsLocData = _.find(resp.responseObject, ["loctype", "sds_loc"]);
					const hdLocData = _.find(resp.responseObject, ["loctype", "hd_loc"]);
					const willCallLocData = _.find(resp.responseObject, ["loctype", "sds_will_call_loc"]);
					const adcLocData = _.find(resp.responseObject, ["loctype", "adc_loc"]);
					const adcWillCallLocData = _.find(resp.responseObject, ["loctype", "adc_will_call_loc"]);

					if(sdsLocData || hdLocData || willCallLocData || adcWillCallLocData || adcLocData){
						self.setState({
							shippingAddress: sdsLocData ? sdsLocData : hdLocData,
							willCallLocData: willCallLocData ? willCallLocData : adcWillCallLocData,
							adcLocData,
							isServiceProvided: sdsLocData?true:false
						})
					} else {
						self.setState({
							errorFlag: true,
							errorMessage: 'No data found.'
						})
					}
				}
			});
		}
    }

	handleKeyPress(event){
		var charCode = event.which || event.keyCode;

        if (!(charCode >= 48 && charCode <= 57)) {
			event.preventDefault();
		}
	}

    render() {
		const self = this;
		const {
			errorFlag,
			errorMessage,
			willCallLocData,
			adcLocData,
			shippingAddress
		} = self.state;
        return (
            <div>
                <div className="push">
                    <h1 className="Page Title">Carrier Information</h1>
                </div>
                <div>
                    <h3 className="Page Subtitle">Search a zip code</h3>
                    <input type="text" name="warecarrierzip" onDrop={this.props.doNothing.bind(this)} onPaste={this.props.doNothing.bind(this)} onKeyPress={this.handleKeyPress.bind(this)} onChange={this.handleSearchInput.bind(this)} maxLength={5} /> &nbsp;
					<input type="submit" onClick={this.handleSearchResult.bind(this)} />
                </div>
				{errorFlag ?
		            <div id="invalid_Zipcode" style={{verticalAlign: 'top'}} >
		                <p style={{color: '#c00'}}><b>{errorMessage}</b></p>
		            </div>:null
	            }
				{(shippingAddress || willCallLocData || adcLocData) && <div id="search_ware_carrier_results" style={{marginTop: 25, paddingTop: 25, borderTop: '1px solid #999'}}>
                    <div className="columns threeColumns">
                        {shippingAddress && <div className="column" style={{verticalAlign: 'top'}}>
                            <h3>SDS Carrier</h3>
                            <p className="push">
								{shippingAddress.inventoryLoc && <span>{shippingAddress.inventoryLoc}<br /></span>}
								{shippingAddress.dockname && <span>{shippingAddress.dockname}<br /></span>}
								<span>{shippingAddress.dockaddr}<br /></span>
								<span>{shippingAddress.dockcity + ', ' + shippingAddress.dockst + ' ' + shippingAddress.dockzip}<br /></span>
								{shippingAddress.dockphone && <span>{this.props.normalizePhoneNumber(shippingAddress.dockphone)}<br /></span>}
                            </p>
                            <p className="push">
                                Services Provided: {this.state.isServiceProvided ? 'Yes' : 'No'}
                            </p>
                        </div>}
						{willCallLocData  && <div className="column" style={{verticalAlign: 'top'}}>
                            <h3>Will Call</h3>
                            <p className="push">
								{willCallLocData.inventoryLoc && <span>{willCallLocData.inventoryLoc}<br /></span>}
								{willCallLocData.dockname && <span>{willCallLocData.dockname}<br /></span>}
								<span>{willCallLocData.dockaddr}<br /></span>
								<span>{willCallLocData.dockcity + ', ' + willCallLocData.dockst + ' ' + willCallLocData.dockzip}<br /></span>
								{willCallLocData.dockphone && <span>{this.props.normalizePhoneNumber(willCallLocData.dockphone)}<br /></span>}
                            </p>
                        </div>}
						{adcLocData && <div className="column" style={{verticalAlign: 'top'}}>
                            <h3>ADC Warehouse</h3>
                            <p className="push">
								{adcLocData.inventoryLoc && <span>{adcLocData.inventoryLoc}<br /></span>}
								{adcLocData.dockname && <span>{adcLocData.dockname}<br /></span>}
								<span>{adcLocData.dockaddr}<br /></span>
								<span>{adcLocData.dockcity + ', ' + adcLocData.dockst + ' ' + adcLocData.dockzip}<br /></span>
								{adcLocData.dockphone && <span>{this.props.normalizePhoneNumber(adcLocData.dockphone)}<br /></span>}
                            </p>
                        </div>}
                    </div>
            	</div>}
            </div>
        );
    }
}
const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getShippingAddresses: (queryStringParams, showLoader, callback) => dispatch(getShippingAddresses(queryStringParams, showLoader, callback)),
});

CarrierInfo = connect(mapStateToProps, mapDispatchToProps)(CarrierInfo);
export default CarrierInfo;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/CarrierInfo/index.js